import React, { Suspense } from 'react'
import { Loading } from '@pandiafi/design-system'
import { useLocation, useSearchParams } from 'react-router-dom'
import { z } from 'zod'
import { useTranslation } from 'react-i18next'

import { RegisterRedirect } from './redirect'
import { RegisterDataLoader } from './RegisterDataLoader'
import { Error } from '../../../components'

const registerAuthType = z.enum(['telia'])
const stateSchema = z.object({
  authType: registerAuthType,
})

export type RegistrationState = z.infer<typeof stateSchema>

export const RegisterAuth: React.FC = () => {
  const { t } = useTranslation(['errors'])
  const { state } = useLocation()
  const [params] = useSearchParams()
  const provider = registerAuthType.safeParse(params.get('provider'))
  const validatedState = stateSchema.safeParse(state)
  const authType = validatedState.success
    ? validatedState.data.authType
    : provider.data

  if (!authType) {
    return <Error message={t('other.incorrectRegistrationProvider')} />
  }

  return (
    <Suspense fallback={<Loading variant="details" />}>
      <RegisterDataLoader authType={authType}>
        {({ teliaLink, loading }) => (
          <RegisterRedirect
            loading={loading}
            teliaLink={teliaLink}
            authType={authType}
          />
        )}
      </RegisterDataLoader>
    </Suspense>
  )
}
